import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { ToastService } from "@app/services";
import { StateStatus } from "@app/state/model";
import {
  selectDiveLogTemplatesStatus,
  selectDiveLogTemplatesTotal,
} from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { combineLatest, filter, map, take, tap } from "rxjs";

export const logTemplateGuard: CanActivateFn = () => {
  const store = inject(Store);
  const toast = inject(ToastService);
  return combineLatest([
    store.select(selectDiveLogTemplatesStatus),
    store.select(selectDiveLogTemplatesTotal),
  ]).pipe(
    tap(([status, total]) => {
      if (total > 0) return;
      switch (status) {
        case StateStatus.Pending:
          toast.show("Dive Log Templates pending to load...");
          break;
        case StateStatus.Loading:
          toast.show("Dive Log Templates loading...");
          break;
        case StateStatus.Error:
          toast.show("Dive Log Templates failed to load...");
          break;
      }
    }),
    filter(
      ([status, total]) =>
        total > 0 ||
        status === StateStatus.Success ||
        status === StateStatus.Error
    ),
    map(([status, total]) => total > 0 || status === StateStatus.Success),
    take(1)
  );
};
